import * as React from 'react';
import { connect } from 'react-redux';
import { TShirtHeroHeader } from './TShirtHeroHeader'
import { TShirtHeroFooter} from './TShirtHeroFooter'
import { TShirtHeroRegister } from './TShirtHeroRegister'
import {CSSProperties} from 'react';
import * as Tgcc from '../../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import {browserHistory} from 'react-router';

const mainImage = Tgcc.ResolveUrl('~/images/superhero-title.png');
const sketchImage1 = Tgcc.ResolveUrl('~/images/sketchhero1.png');
const sketchImage2 = Tgcc.ResolveUrl('~/images/sketchhero2.png');

// Dark theme styles
const darkThemeStyle: CSSProperties = {
    backgroundColor: '#000',
    color: '#fff',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between', // Make sure this is a valid value
    alignItems: 'center',
    padding: '20px',
    '@media (max-width: 768px)': {
        padding: '10px',
        flexDirection: 'column',
        alignItems: 'stretch',
    },
  };

const formStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    width: '35vw',
    backgroundColor: '#71697A',
    padding: '20px',
    borderRadius: '5px'
};

const inputStyle: CSSProperties = {
    marginBottom: '10px',
    padding: '10px',
    borderRadius: '5px',
    border: 'none',
    color: '#000', // Changed to black for visibility
    backgroundColor: '#fff', // Ensure background is light for contrast
};

const buttonStyle: CSSProperties = {
    padding: '10px',
    borderRadius: '5px',
    backgroundColor: 'rgb(104, 147, 204)',
    color: '#fff',
    cursor: 'pointer',
    '@media (max-width: 768px)': {
        width: '50%',
        marginRight: 'auto',
        marginLeft: 'auto',
    },

};

const registrationHeaderStyle: CSSProperties = {
    fontFamily: "Bangers",
    textAlign: 'center',
};

const hashtagStyle: CSSProperties = {
    textAlign: 'center',
    marginBottom: '30px',
    fontSize: '4rem',
    textTransform: 'uppercase',
    fontFamily: "trajan-color",
    letterSpacing: '3px',
    animation: 'glow 3s ease-in-out infinite alternate',
    '@media (max-width: 768px)': {
        fontSize: '3rem',
    },
};

const termsTextStyle: CSSProperties = {
    fontSize: '0.9rem',
    textAlign: 'center',
    color: '#fff',
    maxWidth: '30vw',
    marginTop: '20px',
    '@media (max-width: 768px)': {
        maxWidth: '55vw',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
};


const clickableTermsStyle: CSSProperties = {
    textDecoration: 'underline',
    cursor: 'pointer',
    color: '#fff',
};


const mainImageStyle: CSSProperties = {
    maxWidth: '40vw',
    height: 'auto',
    '@media (max-width: 768px)': {
        maxWidth: '90vw',
    },
};

//Animation Colors
const keyframes = `
@keyframes glow {
  0% {
    text-shadow:
      0 0 8px #FFD700, /* Yellow */
      0 0 16px #FF8C00, /* Orange */
      0 0 24px #00008B, /* Deep Blue */
      0 0 32px #FF4500; /* Red */
  }
  25% {
    text-shadow:
      0 0 16px #FF8C00, /* Orange */
      0 0 24px #FF4500, /* Red */
      0 0 32px #FFD700, /* Yellow */
      0 0 40px #00008B; /* Deep Blue */
  }
  50% {
    text-shadow:
      0 0 24px #FF4500, /* Red */
      0 0 32px #00008B, /* Deep Blue */
      0 0 40px #FF8C00, /* Orange */
      0 0 48px #FFD700; /* Yellow */
  }
  75% {
    text-shadow:
      0 0 32px #00008B, /* Deep Blue */
      0 0 40px #FFD700, /* Yellow */
      0 0 48px #FF4500, /* Red */
      0 0 56px #FF8C00; /* Orange */
  }
  100% {
    text-shadow:
      0 0 40px #FFD700, /* Yellow */
      0 0 48px #FF8C00, /* Orange */
      0 0 56px #FF4500, /* Red */
      0 0 64px #00008B; /* Deep Blue */
  }
}
`;

class _TShirtHero extends React.Component<Tgcc.BaseProps, any> {
    state: any = {
    };

    openLearnMore = () => {
        browserHistory.push(Tgcc.Routes.TShirtHeroLearnMore);
    };

    openTerms = () => {
        browserHistory.push(Tgcc.Routes.TShirtHeroTerms);
    };


    render() {
        const pageLayoutStyle: CSSProperties = {
            display: 'flex',
            justifyContent: 'center', // Aligns children (form and images) in the center
            alignItems: 'center',
        };
    
        const imageStyle: CSSProperties = {
            maxWidth: '400px', // Adjust the size as needed
            height: 'auto',
            margin: '0 20px', // Adds space between the images and the form
        };
    
        return (
            <div style={darkThemeStyle}>
                <TShirtHeroHeader />
                <img src={mainImage} alt="Superheroes" style={mainImageStyle} />
                <div>
                    <style>{keyframes}</style>
                    {/* <h1 style={hashtagStyle}>#TshirtHero</h1> */}
                </div>

                <button onClick={this.openLearnMore} style={buttonStyle}>
                    Learn More
                </button>

                <div style={pageLayoutStyle}>
                    <TShirtHeroRegister state={this.props.state} />
                </div>
                <div style={termsTextStyle}>
                    By creating an account or logging in via this platform, or through any affiliated URLs that contain "T-Shirt Hero" or any derivative thereof, you hereby acknowledge and consent to the 
                    <br></br>
                    <span style={clickableTermsStyle} onClick={this.openTerms}>
                         Terms and Conditions
                    </span>
                </div>
                <TShirtHeroFooter />
            </div>
        );
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return {
        // your state mapping
    };
};

export var TShirtHero =  connect(mapStateToProps)(Radium(_TShirtHero));
